import {FormControlLabel,Switch} from "@mui/material"

const HotelSwitch = ({isChecked,label,onChange}) => {

    return (
        <FormControlLabel control={<Switch checked={isChecked} onChange={(event) => {onChange(event.target.checked)}} />} label={label} />
    )
}

export default HotelSwitch